var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuAlt3 = function SvgMenuAlt3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M2.25 4.75A.75.75 0 0 1 3 4h14a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75m0 5.25A.75.75 0 0 1 3 9.25h14a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75m7.875 5.25a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 0 1.5h-6.125a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgMenuAlt3;